export function useIntersectionObserver(callback: any, customOptions = {}) {
  const elements = ref([]);
  const observer = ref(null);
  let options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
    ...customOptions,
  };

  onMounted(() => {
    setTimeout(() => {
      observer.value = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (callback) {
            callback(entry);
          }
        });
      }, options);

      elements.value.forEach((el) => {
        if (observer.value) observer.value.observe(el);
      });
    }, 10);
  });

  onUnmounted(() => {
    elements.value.forEach((el) => {
      if (observer.value) observer.value.unobserve(el);
    });
  });

  return {
    elements,
    observer,
  };
}